import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store/store';  //ver donde se crea el archivo
import VueNumerals from 'vue-numerals';
import _ from 'lodash';
import 'sweetalert2/dist/sweetalert2.min.css';



Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios)
Vue.use(VueNumerals, {
  locale: 'es'
});
Vue.use(_);

Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
